import { injectSourceIntoUrl } from "@/config/unified-search-config";
import { DestinationCard } from "@/types/dto/homepage/homepage-types";
import {alpha, Box} from "@mui/material";
import React from "react";

interface PlacesDiscoverCardProps {
  cardData: DestinationCard;
  index?: number;
}

const PlacesDiscoverCard = ({ cardData, index }: PlacesDiscoverCardProps) => {
  const { basicInfo, image, card } = cardData || {};
  const buttonItemUrl = card?.url
    ? injectSourceIntoUrl(card.url, "homepage")
    : "";
  return (
    <Box
      component="a"
      data-testid={`discoverCard-${index}`}
      href={buttonItemUrl}
      data-track="click"
      rel="noopener noreferrer"
      sx={{
        height: "295px",
        position: "relative",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        fontSize: "28px",
        color: "common.white",
        fontWeight: "600",
        justifyContent: "center",
        borderRadius: "20px",
        overflow: "hidden",
        cursor: "pointer",
        background: "none",
        "&::before": {
          content: "''",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
          backgroundImage: (theme) => `linear-gradient(180deg, ${alpha(theme.palette.common.black, 0)} 0%, ${alpha(theme.palette.common.black, 0.35)} 54.77%), url(${image?.imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          transition: "transform 0.3s ease-in-out"
        },
        "&:hover::before": {
          transform: "scale(1.05)"
        }
      }}
    >
      <Box
        data-testid={`overlay-text-${index}`}
        component="p"
        sx={{ position: "relative", zIndex: 1, width: "100%", textTransform: "uppercase" }}
      >
        {basicInfo?.headerText}
      </Box>
    </Box>
  );
};

export default PlacesDiscoverCard;
